import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Search, LayoutDashboard, Users, Clock, Settings, LogOut, Plus } from 'lucide-react';

export default function Layout() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const navItems = [
    { path: '/search', label: 'Search Resumes', icon: Search },
    { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/history', label: 'Search History', icon: Clock },
  ];
  const adminItems = [
    { path: '/resumes/new', label: 'Add Resume', icon: Plus },
    { path: '/users', label: 'Manage Users', icon: Users },
  ];
  const handleLogout = () => { logout(); navigate('/login'); };
  const initial = (user?.username || '?')[0].toUpperCase();

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-brand"><h1>Talent<span>Vault</span></h1><p>Resume Search</p></div>
        <nav className="sidebar-nav">
          <div className="nav-section">Main</div>
          {navItems.map(it => (
            <button key={it.path} className={`nav-link ${loc.pathname === it.path ? 'active' : ''}`} onClick={() => navigate(it.path)}>
              <it.icon /> {it.label}
            </button>
          ))}
          {isAdmin && (<>
            <div className="nav-section">Administration</div>
            {adminItems.map(it => (
              <button key={it.path} className={`nav-link ${loc.pathname === it.path ? 'active' : ''}`} onClick={() => navigate(it.path)}>
                <it.icon /> {it.label}
              </button>
            ))}
          </>)}
          <div style={{ flex: 1 }} />
          <button className="nav-link" onClick={() => navigate('/settings')}><Settings /> Settings</button>
          <button className="nav-link" onClick={handleLogout}><LogOut /> Sign Out</button>
        </nav>
        <div className="sidebar-footer">
          <div className="user-card">
            <div className="user-avatar">{initial}</div>
            <div className="user-info"><div className="name">{user?.username}</div><div className="role">{user?.role}</div></div>
          </div>
        </div>
      </aside>
      <main className="main-content"><Outlet /></main>
    </div>
  );
}
